<template>
  <CContainer class="d-flex align-items-center min-vh">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
          <div class="text-center">
            <!-- <h1 class="display-3 mr-4">Welcome</h1> -->
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      permissionList: [],
    };
  },
  async created() {
    await this.getPermissionByUser();
    await this.handleFistPath();
  },
  methods: {
    async handleFistPath() {
      if (this.permissionList.length > 0) {
        let pathUrl = "";
        let i = 0;
        do {
          let permission = this.permissionList[i];
          if (permission.parentPermissionId == 0) {
            if (permission.subMenu.length > 0) {
              pathUrl = permission.subMenu[0].link;
            } else if (permission.link) {
              pathUrl = permission.link;
            }
          }
          i++;
        } while (!pathUrl && i <= this.permissionList.length - 1);
        if (pathUrl) {
          this.$router.push({ path: pathUrl }).catch(() => {});
        }
      }
    },
    async getPermissionByUser() {
      this.isLoadingData = true;
      await this.axios
        .get(`${this.$baseUrl}/Permission`)
        .then(async (data) => {
          if (data.result == 1) {
            this.permissionList = data.detail.permission;
            this.isLoadingData = false;
          } else {
            this.isLoadingData = false;
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.detail,
            });
          }
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
  },
};
</script>
